import { DialogActions, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useState } from 'react';
import { IconButton } from 'rsuite';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { changeDateFormate } from 'src/utils/dateutils';

const StaffAdvance = () => {
  const [data, setData] = useState(null); // Expecting an object
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const staffId = queryParams.get('staffId');

  const { fetchStaffAdvanceById, activeBranchId } = useMain();
  const navigate = useNavigate();

  const handleDetails = (salary) => {
    navigate('/payslip', { state: { staff: data, salarySlip: salary } });
  };
  const handleBack = () => {
        navigate('/attendance');
    };

  const getData = async (staffId) => {
    try {
      setLoading(true);
      const res = await fetchStaffAdvanceById(staffId, activeBranchId);
      if (res.statusCode === 200) {
        setData(res.data || {}); // Store the object directly
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (staffId && activeBranchId) {
      getData(staffId);
    }
    return () => {
      setData(null);
    };
  }, [staffId, activeBranchId]);
  console.log(data, 'data');
  return (
    <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' }, padding: '20px' }}>
      {loading ? (
        <ShowLoader />
      ) : data ? (
        <>
          {/* Staff Details */}
          <div className="staff-details" style={{ marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3 style={{ margin: 0 }}><strong>Staff Name : </strong>{data.name}</h3>

                               <Button
                                variant="contained"
                                onClick={handleBack}
                                sx={{
                                    color: "#757575",
                                    backgroundColor: "white",
                                    boxShadow: "none",
                                    "&:hover": {
                                        backgroundColor: "white",
                                        boxShadow: "none",
                                    },
                                }}
                            >
                                <ArrowBackIcon />
                            </Button>
                            </div>

                            <p><strong>Date of Joining:</strong> {data.dateOfJoining ? data.dateOfJoining.split('-').reverse().join('-') : ''}</p>
                            <p><strong>Department:</strong> {data.department}</p>
                        </div>

          {/* Salary Table */}
          <table className="table-container mt-3">
            <thead className="table-thead">
              <tr>
                {['Date Of Payment', 'Amount', 'Mode Of Payment', 'Paid For'].map((h, index) => (
                  <th key={index} style={{ width: '100%' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-tbody">
              {data.expenses?.map((expense, index) => (
                <tr key={index}>
                  <td style={{ width: '100%' }}>{changeDateFormate(expense.date) ?? '-'}</td>
                  <td style={{ width: '100%' }}>{expense.amountPaid ?? '-'}</td>
                  <td style={{ width: '100%' }}>{expense.modeOfPayment ?? '-'}</td>
                  <td style={{ width: '100%' }}>{expense.typeOfExpense ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>No data available</p>
      )}
    </Box>
  );
};

export default StaffAdvance;
